import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

/**
 * usePremium — central source-of-truth for subscription status.
 * Returns { isPremium, isAdmin, trialDaysLeft, tier, expiresAt, loading, refresh }
 */
export function usePremium() {
  const [status, setStatus] = useState({ loading: true });

  const refresh = useCallback(async () => {
    try {
      const r = await api.get('/subscription/status');
      setStatus({ loading: false, ...r.data });
    } catch {
      setStatus({ loading: false, is_premium: false, trial_active: false });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return {
    loading: status.loading,
    isPremium: !!status.is_premium,
    isAdmin: !!status.is_admin,
    trialActive: !!status.trial_active,
    trialDaysLeft: status.trial_days_left || 0,
    subscriptionActive: !!status.subscription_active,
    tier: status.subscription_tier || null,
    expiresAt: status.subscription_expires_at || null,
    // True recurring-billing state
    subscriptionStatus: status.subscription_status || null,           // active, trialing, past_due, canceled, etc
    isRecurring: !!status.subscription_is_recurring,                  // has a real Stripe Subscription (not a legacy one-time pass)
    cancelAtPeriodEnd: !!status.subscription_cancel_at_period_end,
    currentPeriodEnd: status.subscription_current_period_end || null,
    refresh,
  };
}
